module.exports = __webpack_public_path__ + "static/img/btn_popmo_navigation_prev.8023d5b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/btn_popmo_navigation_prev.svg
// module id = CZ7X
// module chunks = 10